/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./Orders.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { Dropdown, Menu } from "antd";
import "swiper/css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { datat } from "../../components/orders/DataTableTemplatingDemo/data";
import { CommuneZimou } from "../../components/orders/DataTableTemplatingDemo/communeZimou";
import API from "../../utils/api-client";
import PaymentProofModal from "./PaymentProofModal";

import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  getDoc,
  Timestamp,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  PencilIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import ModalAdd from "../../components/orders/model/ModelAdd";
import { MessageCircleIcon } from "lucide-react";
import axios from "axios";
import apicache from "../../components/clearCach/clear";
import freeCountries from "../../utils/freeCountries.json";

export default function DigitalOrderProfile() {
  const { t: uiT } = useUiTranslation();
  const location = useLocation();
  const [showSideBar, setShowSideBar] = useState(true);
  const [showSubmenus, setShowSubmenus] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const account = useSelector((state) => state.AccountReducer);
  console.log("country account", account.country);
  const isFreeCountry = freeCountries.includes(account?.country);
  console.log("isFreeCountry", isFreeCountry);
  const orders = useSelector((state) => state.OrdersReducer);
  const store = useSelector((state) => state.StoreReducer);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { id } = useParams();
  const navigate = useNavigate();
  const [orderIds, setOrderIds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const url = "https://orders-management-dev.maystro-delivery.com/api/stores/orders/";
  const url1 = "https://backend.foorweb.store/api/UploadLivraison";
  const url4 = "https://app.noest-dz.com/api/public/create/order";
  const url5 = "https://backend.foorweb.store/api/UploadLivraison";
  const url6 = "https://backend.foorweb.store/api/UploadLivraison";

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleDropdownClick = (e) => {
    if (order?.isValid) {
      Swal.fire({
        title: uiT("ui.orderInactive"),
        text: uiT("orderDetails.alerts.call.text"),
        icon: "info",
        confirmButtonText: uiT("common.ok"),
      });
      e.stopPropagation();
      return;
    }
    setDropdownVisible((prevState) => !prevState);
  };

  useEffect(() => {
    if (orders.length > 0) {
      const ids = orders.map((order) => order.id);
      setOrderIds(ids);
      const currentIndex = ids.indexOf(id);
      setCurrentIndex(currentIndex !== -1 ? currentIndex : 0);
    }
  }, [orders, id]);

  const goToPrevious = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      navigate(`/digital-order-profile/${orderIds[newIndex]}`, {
        replace: true,
      });
    }
  };

  const goToNext = () => {
    if (currentIndex < orderIds.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      navigate(`/digital-order-profile/${orderIds[newIndex]}`, {
        replace: true,
      });
    }
  };

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [dataForm, setDataForm] = useState({
    user: account.uer,
    productId: "",
    name: "",
    phone: "",
    state: "",
    paid: "0",
    address: "",
    commune: "",
    deleveryStatus: "1",
    stopdeskDelivery: false,
    deleveryPrice: 0,
    products: [],
    deliveryPrice: 0,
    qty: "",
    total: 0,
    options: "",
    paymentType: "دفع عند الاستلام",
    timeStamp: serverTimestamp(),
  });

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading(true);
      try {
        if (location.state && location.state.orderData) {
          setOrder(location.state.orderData);
          return;
        }
        const orderRef = doc(db, "orders", id);
        const orderSnap = await getDoc(orderRef);
        if (orderSnap.exists()) {
          setOrder(orderSnap.data());
        } else {
          console.error("No such document!");
          Swal.fire({
            title: uiT("ship.error"),
            text: uiT("orderDetails.alerts.notFoundText"),
            icon: "error",
            confirmButtonText: uiT("ship.ok"),
          });
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
        Swal.fire({
          title: uiT("ship.error"),
          text: uiT("orderDetails.alerts.fetchErrorText"),
          icon: "error",
          confirmButtonText: uiT("ship.ok"),
        });
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [id, location.state, uiT]);
  const STATUS_LABELS = {
    0: "جديد",
    1: "انتظار دفع العميل",
    2: "انتظار تأكيد الدفع",
    3: "مدفوع و انتظار المنتج",
    4: "الدفع مرفوض",
    5: "مكتملة",
  };
  const toggleSubmenu = (products) => {
    setShowSubmenus((prevShowSubmenus) => ({
      ...prevShowSubmenus,
      [products]: !prevShowSubmenus[products],
    }));
  };

  const handleUpdate = async (order) => {
    console.log("Order ID:", order);

    setDataForm(order);
    setShowModal(true);
  };

  const handleModalSave = (updatedOrderData) => {
    setOrder(updatedOrderData); // Update local state
  };

  const onDeleteProduct = async (productToDelete) => {
    try {
      // Log the clicked product name and order ID
      console.log("Product to delete:", productToDelete.name);
      console.log("Order ID:", id);
      if (!id) {
        console.error("Order ID is missing or undefined.");
        Swal.fire(uiT("ship.error"), "رقم الطلب غير متوفر.", "error");
        return;
      }
      if (data && data.products && data.products.length === 1) {
        Swal.fire({
          title: uiT("orderDetails.alerts.lastProductDeletionTitle"),
          text: uiT("orderDetails.alerts.lastProductDeletionText"),
          icon: "warning",
          confirmButtonText: uiT("ship.ok"),
          confirmButtonColor: "#6c757d",
        });
        return;
      }
      const result = await Swal.fire({
        title: uiT("cashBack.swal.deleteConfirm.title"),
        text: uiT("orderDetails.alerts.confirmDeleteText"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: uiT("ship.delete"),
        cancelButtonText: uiT("annule"),
      });

      if (result.isConfirmed) {
        // Check if we're online
        if (!navigator.onLine) {
          Swal.fire({
            title: uiT("orderDetails.alerts.offlineTitle"),
            text: uiT("orderDetails.alerts.offlineText"),
            icon: "error",
            confirmButtonText: uiT("ship.ok"),
          });
          return;
        }

        // Use data from Redux instead of fetching from Firebase
        if (data) {
          const currentProducts = data.products || [];

          console.log("Current products:", currentProducts); // Log existing products

          // Remove the product by name
          const updatedProducts = currentProducts.filter(
            (product) => product.name !== productToDelete.name
          );

          console.log("Updated products after deletion:", updatedProducts); // Log updated products

          // Recalculate the total price
          const updatedTotal = updatedProducts.reduce((acc, product) => {
            return acc + product.price * product.quantity;
          }, 0);

          // Update the document in Firebase
          await updateDoc(doc(db, "orders", id), {
            products: updatedProducts,
            total: updatedTotal,
          });

          // Update the state locally
          setOrder((prevOrder) => ({
            ...prevOrder,
            products: updatedProducts,
            total: updatedTotal,
          }));

          console.log("Successfully deleted from Firestore");

          // Show success message
          Swal.fire(uiT("ship.delete_success"), "تم حذف المنتج بنجاح.", "success");
        } else {
          console.error("Order not found in Redux!");
          Swal.fire(uiT("ship.error"), "لم يتم العثور على الطلب.", "error");
        }
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      Swal.fire(uiT("ship.error"), "فشل في حذف المنتج.", "error");
    }
  };

  const statusOptions = {
    1: "جديد",
    3: "مؤكدة",
    "11-2": "لم يرد على الاتصال",
    "11-3": "مؤجلة",
    6: "ملغي",
    "11-5": "ملغى من قبل العميل",
    "11-1": "انتظار اتصال العميل",
    "11-4": "الخط مغلق",
    4: "رفع لشركة التوصيل",
    5: "مكتملة",
  };

  const statusOptions2 = [
    {
      value: "3",
      label: uiT("stats.confirmed"),
      color: "#25c7bf",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/8888/8888205.png",
    },
    {
      value: "4",
      label: uiT("delivery.on_shipping"),
      color: "#8c5fa5",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/1559/1559859.png",
    },
    {
      value: "5",
      label: uiT("orders.completed"),
      color: "#49a688",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/6815/6815043.png",
    },
    {
      value: "6",
      label: uiT("orderDetails.statusOptions.6"),
      color: "#e87778",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/391/391247.png",
    },
    {
      value: "11-1",
      label: uiT("ui.awaitingCustomer"),
      color: "#0074D9",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/2593/2593514.png",
    },
    {
      value: "11-2",
      label: uiT("ui.noAnswer"),
      color: "#D3D3D9",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/9946/9946401.png",
    },
    {
      value: "11-3",
      label: uiT("stats.postponed"),
      color: "#e1a626",
      buttonImage: "../agenda.png",
    },
    {
      value: "11-4",
      label: uiT("ui.lineClosed"),
      color: "#000000",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/8402/8402548.png",
    },
    {
      value: "11-5",
      label: uiT("ui.cancelledByCustomer"),
      color: "#800080",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/7787/7787073.png",
    },
  ];

  const orderCurrent = orders.find((order) => order.id === id);
  const STATUS_CONFIG = {
    0: {
      label: uiT("orders.new"),
      icon: "bi bi-file-earmark-plus",
      image: "https://cdn-icons-png.flaticon.com/512/10608/10608900.png",
    },
    1: {
      label: uiT("dashboard.digitalcards.statuses.waitingPayment"),
      icon: "bi bi-credit-card",
      image: "https://cdn-icons-png.flaticon.com/512/6607/6607497.png",
    },
    2: {
      label: uiT("dashboard.digitalcards.statuses.waitingConfirmation"),
      icon: "bi bi-clock-history",
      image: "https://cdn-icons-png.flaticon.com/512/18964/18964041.png",
    },
    3: {
      label: uiT("orders.paid"),
      icon: "bi bi-check-circle",
      image: "https://cdn-icons-png.flaticon.com/128/8888/8888205.png",
    },
    4: {
      label: uiT("services.foorCall.status.rejected"),
      icon: "bi bi-x-circle",
      image: "https://cdn-icons-png.flaticon.com/128/391/391247.png",
    },
    5: {
      label: uiT("ui.completed"),
      icon: "bi bi-check-all",
      image: "https://cdn-icons-png.flaticon.com/128/6815/6815043.png",
    },
  };
  const changeStatus = async (newStatus) => {
    if (!navigator.onLine) {
      Swal.fire({
        title: uiT("orderDetails.alerts.offlineTitle"),
        text: uiT("ui.offlineStatusError"),
        icon: "error",
        confirmButtonText: uiT("ship.ok"),
      });
      return;
    }
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(order.statusTimeline || []),
      { status: newStatus, timestamp: currentTime, ownby: account?.name },
    ];

    try {
      const dataToUpdate = {
        ...order,
        status: newStatus,
        statusTimeline: updatedStatusTimeline,
      };

      if (newStatus === 5) {
        const response = await axios.post("https://master.foorweb.online/api/digital/orders/deliver-content", {
          id: dataToUpdate.id,
        });
        const updatedOrder = {
          ...response.data.order,
          id: response.data.orderId,
          timeStamp: new Timestamp(
            response.data.order.timeStamp._seconds,
            response.data.order.timeStamp._nanoseconds
          ),
        };
        setOrder(updatedOrder);
      } else {
        const response = await API.put("digital/orders/update", {
          data: dataToUpdate,
        });
        const updatedOrder = {
          ...response.data.order,
          id: response.data.orderId,
          timeStamp: new Timestamp(
            response.data.order.timeStamp._seconds,
            response.data.order.timeStamp._nanoseconds
          ),
        };
        setOrder(updatedOrder);
      }
      Swal.fire(uiT("ui.updated"), "تم تحديث حالة الطلب بنجاح.", "success");
    } catch (error) {
      alert(uiT("ui.genericError"));
      console.error("Error updating order via API:", error);
    }
  };

  const getAllowedStatuses = (currentStatus) => {
    switch (currentStatus) {
      case 0:
        return [1, 2, 3, 4];
      case 1:
        return [3, 4];
      case 2:
        return [3, 4];
      case 3:
        return [5];
      case 4:
        return [];
      case 5:
        return [];
      default:
        return [];
    }
  };

  const data = useSelector((state) =>
    state.OrdersReducer.find((order) => order.id === id)
  );

  const allowedStatuses = getAllowedStatuses(order?.status || 0);

  const menu =
    allowedStatuses.length > 0 ? (
      <Menu>
        {allowedStatuses.map((statusId, index) => (
          <div key={statusId}>
            {index > 0 && <hr className="m-0 p-0" />}
            <Menu.Item
              key={statusId}
              className={`ms-33 ss1 ${
                order?.status === statusId ? "selected" : ""
              }`}
              onClick={() => {
                changeStatus(statusId);
                setDropdownVisible(false);
              }}
            >
              <div className="s11 flex items-center gap-2">
                <img
                  src={STATUS_CONFIG[statusId].image}
                  alt={STATUS_CONFIG[statusId].label}
                  className="w-5 h-5"
                />
                {STATUS_CONFIG[statusId].label}
              </div>
            </Menu.Item>
          </div>
        ))}
      </Menu>
    ) : null;

  const getStatusText = (status) => {
    return statusOptions[status] || "";
  };

  const messagesByStatus = {
    1: ``,
    2: ``,
    3: `مرحباً ${
      order?.name ? order?.name : ""
    },\nتم تأكيد طلبك بنجاح .🛍 المنتج: ${order?.nameproduct}\n💰إجمالي السعر: ${
      order?.total
    } ${
      store.currencySymbol
    }\nسيتم تجهيز طلبك وإرساله في أقرب وقت.شكرا لثقتك. لا تتردد في التواصل إذا كان لديك أي استفسارات.\nبانتظار خدمتك مجدداً،\n`,
    4: `مرحباً ${
      order?.name ? order?.name : ""
    },\nنود أن نعلمك أنه تم رفع طلبك لشركة التوصيل \n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total} ${
      store.currencySymbol
    }\n  سيتصل بك الموزع خلال أيام ٫نرجو الاستعداد لاستلام المنتج والرد بسرعة. نقدر تفهمك وتعاونك، ونسعى دائمًا لخدمتك بشكل مميز`,
    5: ``,
    6: ` مرحباً ${
      order?.name ? order?.name : ""
    },\nنأسف لإبلاغك بأن طلبك قد تم إلغاؤه و السبب راجع لعدم ردك على إتصالاتنا .\n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total} ${
      store.currencySymbol
    }\n إذا كنت مهتم لا تتردد في الاتصال بنا .\nبانتظار إتصالك`,
    "11-1": ` مرحباً ${
      order?.name ? order?.name : ""
    },\nنحن في انتظار اتصالك لتأكيد طلبك .\n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total}${
      store.currencySymbol
    }\n    نود إعلامك أن الكمية المتاحة من المنتج قد تقترب من النفاذ. ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك\nطاب يومك,`,
    "11-2": `مرحباً ${
      order?.name ? order?.name : ""
    },\nنأسف لعدم الرد على اتصالنا السابق.\nيرجى الاتصال  بنا لتأكيد طلبك:\n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total} ${
      store?.currencySymbol
    }\nبإنتظار تواصلك لتأكيد طلبك ،\n`,
    "11-3": ` مرحباً ${
      order?.name ? order?.name : ""
    },\nنود إعلامك بأنه تم تأجيل طلبك:\n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total} ${
      store.currencySymbol
    }\nسنتواصل معك قريبا لتحديد موعد الإستلام ،\n`,
    "11-4": `مرحباً ${
      order?.name ? order?.name : ""
    },\n لقد قمنا بمحاولة الاتصال بك لتأكيد طلبك، ولكن وجدنا خطك مغلقًا\n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total} ${
      store.currencySymbol
    }\n   يُرجى التأكد من تفعيل الاتصال و ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك \n طاب يومك,`,
    "11-5": ` مرحباً ${
      order?.name ? order?.name : ""
    },\nنأسف لإلغاء طلبك .\n-🛍 المنتج: ${
      order?.nameproduct
    }\n- 💰إجمالي السعر: ${order?.total} ${
      store.currencySymbol
    }\n إذا قررت طلب المنتج في وقت لاحق، فلا تتردد في الاتصال بنا. سنكون سعداء بخدمتك في المستقبل,`,
  };

  const handleTextButtonClick = () => {
    if (!order || !order.phone) {
      Swal.fire(uiT("ship.error"), "رقم الهاتف غير متوفر.", "error");
      return;
    }

    // Check if the order is valid (if isValid is true, prevent sending the message)
    if (order.isValid) {
      Swal.fire({
        title: uiT("ui.cannotSendMessage"),
        text: uiT("orderDetails.alerts.call.text"),
        icon: "info",
        confirmButtonText: uiT("common.ok"),
      });

      return; // Stop further execution if order is valid
    }

    // Get the message based on the order status
    const message = messagesByStatus[order.deleveryStatus];
    console.log("order message", message);

    // Check if there's a message for the current status
    if (!message) {
      Swal.fire(uiT("ship.error"), "لا توجد رسالة محددة لهذه الحالة.", "error");
      return;
    }

    // Encode the message for use in a URL
    const encodedMessage = encodeURIComponent(message);

    // Open SMS with the pre-filled message and phone number
    const smsUrl = `sms:${order.phone}?body=${encodedMessage}`;

    // Directly move to the SMS link without confirmation
    window.location.href = smsUrl;
  };

  if (loading) {
    return <p>{uiT("ui.loadingEllipsis")}</p>;
  }

  if (!order) {
    return <div>{uiT("orderDetails.alerts.notFoundText")}</div>;
  }

  let buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
  let buttonImage2 =
    "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";

  switch (order?.deleveryStatus) {
    case "1":
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
      buttonImage2 =
        "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
      break;
    case "2":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
      buttonImage2 =
        "https://img.freepik.com/free-psd/delivery-box-isometric-3d-render-icon_47987-7574.jpg";
      break;
    case "3":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
      break;
    case "4":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
      break;
    case "5":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
      break;
    case "6":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
      break;
    case "11-1":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
      break;
    case "11-2":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      break;
    case "11-3":
      buttonImage = "../agenda.png";
      buttonImage2 = "../agenda.png";
      break;
    case "11-4":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
      break;
    case "11-5":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
      break;
  }

  const handleCallClick = () => {
    // Check if the order is valid
    if (order.isValid) {
      Swal.fire({
        icon: "info",
        title: uiT("orderDetails.alerts.call.title"),
        text: uiT("orderDetails.alerts.call.text"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    const phoneNumber = order.phone;

    // Check if the phone number exists
    if (!phoneNumber) {
      Swal.fire({
        icon: "error",
        title: uiT("orderDetails.alerts.call.noPhoneTitle"),
        text: uiT("orderDetails.alerts.call.noPhoneText"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return; // Stop further execution if phone number is missing
    }

    // Directly move to the phone call link without confirmation
    window.location.href = `tel:${phoneNumber}`;
  };

  let isFunctionRunning = false;

  const handlePay = async () => {
    if (isFunctionRunning) return;
    isFunctionRunning = true;

    const isOnline = navigator.onLine;
    if (!isOnline) {
      Swal.fire({
        icon: "error",
        title: uiT("ship.no_internet"),
        text: uiT("orderDetails.alerts.internet.text"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false;
      return;
    }

    const currentDate = Math.floor(Date.now() / 1000);

    if (
      account.subscription.tokens > 0 ||
      account.subscription.endDate.seconds > currentDate
    ) {
      // Update subscription if using tokens
      await setDoc(doc(db, "account", account.id), {
        ...account,
        subscription: !(account.subscription.endDate.seconds > currentDate)
          ? { ...account.subscription, tokens: account.subscription.tokens - 1 }
          : { ...account.subscription },
      });

      // Update order as invalid (used)
      await updateDoc(doc(db, "orders", id), {
        isValid: false,
      });

      // Update UI without refresh
      setOrder((prev) => ({ ...prev, isValid: false }));

      Swal.fire({
        icon: "success",
        title: uiT("orderDetails.alerts.activation.successTitle"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });

      isFunctionRunning = false;
    } else {
      Swal.fire({
        icon: "error",
        title: uiT("ship.insufficient_balance"),
        text: uiT("ship.insufficient_balance_message"),
        confirmButtonText: uiT("ship.recharge_balance"),
        confirmButtonColor: "rgb(141, 93, 167)",
        showCancelButton: true,
        cancelButtonText: uiT("annule"),
        cancelButtonColor: "#e87778",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/plan";
        }
        isFunctionRunning = false;
      });
    }
  };

  const addIpToAdressipblock = async (order) => {
    Swal.fire({
      title: uiT("ship.confirm_block"),
      text: uiT("orderDetails.alerts.block.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: uiT("ship.confirm_block_button"),
      cancelButtonText: uiT("annule"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const storeDocRef = doc(db, "store", store.id);
        if (order.ipAddress) {
          try {
            await updateDoc(storeDocRef, {
              Adressipblock: arrayUnion(order.ipAddress),
            });
            console.log("الايبي added successfully!");
            apicache(account, products);
            Swal.fire(uiT("ship.block_success"), ". تم حظر عنوان الايبي بنجاح", "success");
          } catch (error) {
            console.error("Error adding الايبي: ", error);
            Swal.fire(uiT("ship.error"), ". حدث خطأ أثناء حظر عنوان الايبي", "error");
          }
        } else {
          console.error("No الايبي address found in data");
          Swal.fire(uiT("ship.error"), "لا يوجد عنوان الايبي في البيانات.", "error");
        }
      }
    });
  };

  const removeIpFromAdressipblock = async (order) => {
    Swal.fire({
      title: uiT("ship.confirm_delete"),
      text: uiT("orderDetails.alerts.unblock.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: uiT("orderDetails.alerts.unblock.confirm"),
      cancelButtonText: uiT("annule"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const storeDocRef = doc(db, "store", store.id);

        if (order.ipAddress) {
          try {
            await updateDoc(storeDocRef, {
              Adressipblock: arrayRemove(order.ipAddress),
            });
            console.log("الايبي removed successfully!");
            Swal.fire(uiT("ship.delete_success"), ". تم حذف عنوان الايبي بنجاح", "success");
          } catch (error) {
            console.error("Error removing الايبي: ", error);
            Swal.fire(uiT("ship.error"), ". حدث خطأ أثناء حذف عنوان الايبي", "error");
          }
        } else {
          console.error("No الايبي address found in data");
          Swal.fire(uiT("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
        }
      }
    });
  };
  return (
    <div className="container-fluid">
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full mb-4"
          style={{
            flex: 1,
            backgroundColor: "#fbf8fc",
          }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          <div className="m-1 p-0 bg-white">
            <div className="flex flex-col items-center  w-full">
              {/* الجزء العلوي الأزرق */}

              <div className="bg-[#5a2b73] w-full h-20 flex justify-center relative rounded-t-lg">
                <div className="absolute top-[10px] flex justify-center">
                  {order?.products?.map((product, index) => (
                    <div className="w-24 h-24 rounded-full border-4 border-[#5a2b73] p-1 bg-white">
                      <img
                        className="w-full h-full rounded-full"
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        alt={uiT("ui.profile")}
                      />
                    </div>
                  ))}
                </div>
              </div>
              {/* الجزء السفلي الأبيض */}
              {order?.products?.[0] && (
                <div className="bg-white p-6 rounded-b-lg w-full mt-5 mb-2 relative">
                  <div className="flex items-center justify-between w-full">
                    <button
                      onClick={goToPrevious}
                      disabled={currentIndex === 0}
                      className={`p-2 rounded-full transition ${
                        currentIndex === 0
                          ? "opacity-50 cursor-not-allowed bg-gray-300"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      <ChevronRightIcon className="h-6 w-6 text-gray-700" />
                    </button>

                    {/* هذا div يستخدم لتوسيط المحتوى */}
                    <div className="absolute left-1/2 transform -translate-x-1/2 text-center">
                      {isFreeCountry ? (
                        <a
                          href={`tel:${order.phone}`}
                          style={{ textDecoration: "none" }}
                        >
                          <p className="m-0 text-green-600 font-bold">
                            {order.phone}
                          </p>
                        </a>
                      ) : order.isValid ? (
                        <i className="fs-3" onClick={handlePay}>
                          <img className="mx-auto" src="/lock.png" alt={uiT("orderDetails.top_section.image_alt")} />
                        </i>
                      ) : (
                        <a
                          href={`tel:${order.phone}`}
                          style={{ textDecoration: "none" }}
                        >
                          <p className="m-0 text-green-600 font-bold">
                            {order.phone}
                          </p>
                        </a>
                      )}

                      <p className="text-gray-600">
                        {order.timeStamp
                          ? new Date(
                              order.timeStamp.seconds * 1000
                            ).toLocaleString("ar-DZ", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : uiT("orderDetails.order_status_history.no_date")}
                      </p>
                    </div>

                    <button
                      onClick={goToNext}
                      disabled={currentIndex === orderIds.length - 1}
                      className={`p-2 rounded-full transition ${
                        currentIndex === orderIds.length - 1
                          ? "opacity-50 cursor-not-allowed bg-gray-300"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      <ChevronLeftIcon className="h-6 w-6 text-gray-700" />
                    </button>
                  </div>
                </div>
              )}

              <div className="flex space-x-2 mb-3">
                <button
                  onClick={
                    !!account.store
                      ? () => handleUpdate(order)
                      : () => {
                          message();
                        }
                  }
                  className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/faq.png" style={{ width: "20px" }} />
                </button>
                <button
                  onClick={handleTextButtonClick}
                  className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/speech-bubble.png" style={{ width: "20px" }} />
                </button>
                <button
                  onClick={handleCallClick}
                  className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/phone-call.png" style={{ width: "20px" }} />
                </button>

                {allowedStatuses.length === 0 ? (
                  <button className="flex items-center relative justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot mx-auto">
                    <img
                      src={
                        STATUS_CONFIG[order?.status]?.image ||
                        "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                      }
                      style={{ width: "20px" }}
                      alt={uiT("ui.buttonIcon")}
                    />
                  </button>
                ) : (
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    visible={dropdownVisible}
                  >
                    <button
                      className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot"
                      onClick={handleDropdownClick}
                    >
                      <img
                        src={
                          STATUS_CONFIG[order?.status]?.image ||
                          "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                        }
                        style={{ width: "20px" }}
                        alt={uiT("ui.buttonIcon")}
                      />
                    </button>
                  </Dropdown>
                )}
              </div>
              {order?.products?.map((product, index) => (
                <div
                  key={index}
                  className="max-w-2xl mx-auto py-0 md:px-2 relative mt-4 w-100 p-2"
                >
                  <div
                    onClick={() => toggleSubmenu(product.name)}
                    className="d-flex justify-content-between w-100 p-1-2 border4 card"
                  >
                    <li className="flex gap-4 items-center">
                      <img
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        alt={product.name}
                        className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-purple-100"
                      />
                      <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                        {product.name}
                      </div>
                      <span className="text-sm">
                        {product.price} {product?.currencySymbol || uiT("ui.dzd")}
                      </span>
                      <i
                        className={`bi ${
                          showSubmenus[product.name]
                            ? "bi-chevron-double-up"
                            : "bi-chevron-double-down"
                        }`}
                        style={{ color: "#45a788" }}
                      ></i>
                    </li>
                  </div>

                  <span
                    className="absolute top-0 left-0 p-1"
                    style={{
                      backgroundColor: "rgba(69, 167, 77, 0)",
                      marginTop: "-11px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent click event from bubbling up
                    }}
                  >
                    <i
                      onClick={() => onDeleteProduct(product)} // Pass the product to delete
                      className="bi bi-x-circle"
                      style={{ color: "red", fontSize: "18px" }}
                    ></i>
                  </span>
                </div>
              ))}
              <div className="mt-4 grid gap-8 sm:grid-cols-2 lg:grid-cols-2 w-100 p-2">
                <div className=" justify-content-between w-100 p-1-2 border4 card">
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("orderDetails.customer_info.full_name")}</p>
                    <p className="m-0 text-green-600 font-bold">{order.name}</p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("orderDetails.customer_info.phone_number")}</p>
                    {isFreeCountry ? (
                      <a
                        href={`tel:${order.phone}`}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="m-0 text-green-600 font-bold">
                          {order.phone}
                        </p>
                      </a>
                    ) : order?.isValid ? (
                      <i className="fs-3" onClick={handlePay}>
                        <img className="mx-auto " src="/lock.png" alt={uiT("orderDetails.top_section.image_alt")} />
                      </i>
                    ) : (
                      <a
                        href={`tel:${order.phone}`}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="m-0 text-green-600 font-bold">
                          {order.phone}
                        </p>
                      </a>
                    )}
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("ui.emailLabel")} </p>
                    <p className="m-0 text-success">
                      <b>{order.email ? order.email : uiT("ui.notAvailable")}</b>
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("orderDetails.customer_info.customer_note")}</p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.note || uiT("ship.no_note")}
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("ship.ip_address")}</p>
                    <p className="m-0 text-green-600 font-bold">
                      <b>{order.ipAddress ? order.ipAddress : "-"}</b>
                    </p>
                  </div>
                  <hr className="my-1" />
                  {data.status == 2 && (
                    <div className="d-flex justify-content-between w-100 p-1-2-3">
                      <p className="m-0">{uiT("ui.paymentProofLabel")}</p>
                      {data.paymentProof ? (
                        <p
                          className="m-0 font-bold cursor-pointer text-[#9e68ba] hover:opacity-75 transition"
                          onClick={() => setIsModalOpen(true)}
                        >
                          {uiT("ui.open")}
                        </p>
                      ) : (
                        <p className="m-0 text-danger font-bold">{uiT("dontexist")}</p>
                      )}
                    </div>
                  )}
                  <hr className="my-1" />
                </div>

                <div className=" justify-content-between w-100 p-1-2 border4 card">
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("orderDetails.order_summary.product_value")}</p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.total - (order.deliveryPrice || 0)}{" "}
                      {order.currencySymbol}
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("orderDetails.order_summary.quantity")}</p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.qty ?? 1}
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{uiT("ui.productInfoLabel")}</p>
                    <p className="m-0 text-success">
                      <b>{data.products[0].key ?? uiT("ui.toBeDetermined")}</b>
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("ui.orderStatusLabel")}</p>
                    <p className="m-0 text-green-600 font-bold">
                      <b>{STATUS_LABELS[order.status] ?? uiT("unspecified")}</b>
                    </p>
                  </div>

                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 ">
                    <p className="m-0">{uiT("ui.paymentMethodLabel")}</p>
                    <p className="m-0 text-success">
                      <b>{data.paymentMethod ?? uiT("ui.toBeDetermined")}</b>
                    </p>
                  </div>
                  <hr className="m-0 p-0" />

                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">{uiT("orderDetails.order_summary.total")}</p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.total} {order.currencySymbol}
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 mt-2">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => addIpToAdressipblock(order)}
                    >
                      {uiT("ship.block")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-warning"
                      onClick={() => removeIpFromAdressipblock(order)}
                    >
                      {uiT("ship.delete")}
                    </button>
                  </div>
                </div>
              </div>

              <div className="mt-12 w-100 p-3">
                <p className="text-gray-600 text-xl font-semibold sm:text-s">
                  {uiT("orderDetails.order_status_history.title")}
                </p>
                <ul className="mt-2 grid gap-8 sm:grid-cols-1 lg:grid-cols-1">
                  {order.statusTimeline ? (
                    order.statusTimeline.reverse().map((statusUpdate, idx) => (
                      <li
                        key={idx}
                        className="flex gap-4 items-center border4"
                        style={{
                          marginBottom: "-27px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <div className="flex-none w-24 h-24">
                          <img
                            src={
                              statusUpdate.status === "1"
                                ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                                : statusUpdate.status === "2"
                                ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                                : statusUpdate.status === "3"
                                ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                : statusUpdate.status === "4"
                                ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                : statusUpdate.status === "5"
                                ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                : statusUpdate.status === "6"
                                ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                : statusUpdate.status === "11-1"
                                ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                : statusUpdate.status === "11-2"
                                ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                : statusUpdate.status === "11-3"
                                ? "../agenda.png"
                                : statusUpdate.status === "11-4"
                                ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                : statusUpdate.status === "11-5"
                                ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png" // Default image
                            }
                            className="w-full h-full rounded-full"
                            alt=""
                            style={{
                              width: "35px",
                              height: "35px",
                              margin: "20px",
                            }}
                          />
                        </div>
                        <div>
                          <h4 className="font-semibold sm:text-lg">
                            {getStatusText(statusUpdate.status)}
                          </h4>
                          <p className="text-[#9e68ba] mb-0">
                            {statusUpdate.timestamp
                              ? // Check if timestamp is a Firebase Timestamp object
                                statusUpdate.timestamp.seconds
                                ? new Date(
                                    statusUpdate.timestamp.seconds * 1000
                                  ).toLocaleString("ar-DZ", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : // If timestamp is already a JavaScript Date object or string
                                  new Date(
                                    statusUpdate.timestamp
                                  ).toLocaleString("ar-DZ", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                              : uiT("orderDetails.order_status_history.no_date")}
                          </p>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className=""></li>
                  )}
                  <li
                    className="flex gap-4 items-center border4 "
                    style={{
                      marginBottom: "-27px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <div className="flex-none w-24 h-24 ">
                      <img
                        src={
                          "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                        }
                        className="w-full h-full rounded-full"
                        alt=""
                        style={{
                          width: "35px",
                          height: "35px",
                          margin: "20px",
                        }}
                      />
                    </div>
                    <div>
                      <h4 className=" font-semibold sm:text-lg">
                        {uiT("ship.order_received")}
                      </h4>
                      <p className="text-[#9e68ba]">
                        {/* {new Date(order.timestamp.seconds * 1000).toLocaleString()} */}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <ModalAdd
            lgShow={showModal}
            setLgShow={setShowModal}
            dataForm={dataForm}
            setDataForm={setDataForm}
            data={data}
            onSave={handleModalSave}
          />
          <Footer />
        </div>
      </div>
      <PaymentProofModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        paymentProof={order?.paymentProof}
      />
    </div>
  );
}
